import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import UpsellLandingWrapper from '@/components/upsellLanding/UpsellLandingWrapper';
import { InitRequest } from '@/hooks/store';
import type { InitialServerState } from '@/store';
import { resolveCheckoutSessionsEnabled } from '@/utils/experiments/resolveCheckoutSessionsEnabled';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

type Props = {
	initialState: InitialServerState | null;
	isCheckoutSessionsEnabled: boolean;
};

const LifetimeOfferPage = ({ isCheckoutSessionsEnabled }: Props) => {
	return (
		<Layout pageName="lifetime_offer" title="Calm - Lifetime Offer">
			<UpsellLandingWrapper
				bgImg="/_n/images/landing-pages/annual-offer-bg.webp"
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
			/>
		</Layout>
	);
};

export default LifetimeOfferPage;

export const getServerSideProps: GetServerSideProps<Props> = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.PRICES, InitRequest.USER],
		{
			plan: 'lifetime',
		},
	);
	const isCheckoutSessionsEnabled = await resolveCheckoutSessionsEnabled(initialState);

	return {
		props: {
			initialState,
			isCheckoutSessionsEnabled,
		},
	};
};
